module.exports = "/_next/static/images/hardhat-line-1d67652d382a8f081b124e88665dfb8a.svg";